import { Action, createReducer, on } from '@ngrx/store';
import { zefResetState } from '@zerops/zef/core';
import {
  RecipeHandoffPendingState,
  setPendingHandoff,
  setPendingRecipe,
  clearPendingHandoff,
  consumeRecipeHandoffFail
} from './recipe-handoff-base.action';

const initialState: RecipeHandoffPendingState = { id: null, source: null };

const actionReducer = createReducer(
  initialState,
  // First-writer-wins: a re-emitted param-carrying navigation during a
  // multi-step ceremony (e.g. a 2FA step that keeps ?handoff=/?recipe= on
  // /login) must not overwrite or re-arm an already-captured id.
  on(setPendingHandoff, (s, { id }): RecipeHandoffPendingState =>
    s.id === null ? { id, source: 'handoff' } : s),
  on(setPendingRecipe, (s, { id }): RecipeHandoffPendingState =>
    s.id === null ? { id, source: 'recipe' } : s),
  // Happy-path clear (emitted alongside the drain) + failed-consume clear so a
  // 410'd id can't be re-drained by a later storeUserDataSuccess.
  on(clearPendingHandoff, consumeRecipeHandoffFail, (): RecipeHandoffPendingState => initialState),
  // Session-end reset (logout / cross-tab invalidation / checkStoredTokenFail /
  // refreshTokenFail all route through zefResetState). Deliberately NOT keyed on
  // loginFail: a wrong-password retry stays on the same route (no re-capture),
  // so clearing on loginFail would silently drop the handoff on the retry.
  on(zefResetState, (): RecipeHandoffPendingState => initialState)
);

export function recipeHandoffBaseReducer(
  state: RecipeHandoffPendingState,
  action: Action
) {
  return actionReducer(state, action);
}
